import LatestCarousel from '../components/latest-carousel';
import ServicesSectionsNav from '../components/services-sections-nav';

export default {
  init() {
    // JavaScript to be fired on all pages
    if ( document.body.scrollHeight < 1800 ) {
      document.querySelector( '.scroll-to-top' ).style = 'display: none !important';
    }

    // Initialize Latest Insights Carousel
    const latestCarousel = document.querySelector('[data-latest-carousel]');
    if (latestCarousel) {
      new LatestCarousel(latestCarousel);
    }

    // Initialize Services Sections Navigation
    const sectionsNav = document.querySelector('.sections-nav');
    if (sectionsNav) {
      new ServicesSectionsNav(sectionsNav);
    }

    // Show / Hide
    if ( document.getElementById( 'entryLatestCollapse' ) && document.getElementById( 'entryLatestButtons' ) ) {
      let $collapse = $( '#entryLatestCollapse' );
      let $buttons  = $( '#entryLatestButtons' );
      let $showAll  = $buttons.find( 'span.show-all' );
      let $showLess = $buttons.find( 'span.show-less' );

      $collapse.on( 'show.bs.collapse', function() {
        $showAll.addClass( 'd-none' );
        $showLess.removeClass( 'd-none' );
      } );

      $collapse.on( 'hide.bs.collapse', function() {
        $showAll.removeClass( 'd-none' );
        $showLess.addClass( 'd-none' );
      } );
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js